<template>
  <template v-for="newNotification in notifications" :key="newNotification.id">
    <NotificationBanner
      :message="newNotification.message"
      :headline="newNotification.headline"
    />
  </template>
</template>

<script setup>
import NotificationBanner from '@/Components/NotificationBanner.vue'
import { ref, watch } from 'vue'

const props = defineProps({
  notification: {
    type: [Object, null],
    default: null,
  },
})

const notifications = ref([])

let nextId = 0

watch(
  () => props.notification,
  (value) => {
    if (value) {
      // Each message gets its own key and its timer removes that message, not the newest one.
      const id = ++nextId
      notifications.value.push({ ...value, id })
      setTimeout(() => {
        notifications.value = notifications.value.filter(
          (notification) => notification.id !== id,
        )
      }, 5000)
    }
  },
)
</script>
